import React from 'react';

/**
 * Badge Component
 * 
 * Reusable badge component for document status indicators.
 * Used in RightSidebar and ContlyRightSidebar.
 * 
 * @param {string} label - Badge text
 * @param {string} color - Badge color (hex) - used if badgeStyle not provided
 * @param {Object} badgeStyle - Optional badge style object with color, border, background, shadow
 * @param {string} theme - Theme ('dark' or 'light')
 * @param {Object} customStyle - Optional custom style object
 */
const Badge = ({ label, color, badgeStyle, theme = 'dark', customStyle = {} }) => {
  // Use badgeStyle if provided, otherwise use color prop
  const finalStyle = badgeStyle
    ? {
        color: badgeStyle.color,
        border: `1px solid ${badgeStyle.border}`,
        background: badgeStyle.background,
        boxShadow: badgeStyle.shadow,
      }
    : {
        color: color,
        border: `1px solid ${color}40`,
        background: `${color}20`,
        boxShadow: `0 0 8px ${color}30`,
      };

  return (
    <span
      className="doc-badge inline-flex w-fit px-2.5 py-1 rounded-lg text-[10px] font-semibold uppercase tracking-wider mb-1.5"
      style={{
        ...finalStyle,
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        ...customStyle,
      }}
    >
      {label}
    </span>
  );
};

export default Badge;

